var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"event-child"},[(_vm.election.questionnaire && _vm.election.questionnaire.length > 0)?_c('Candidates',{attrs:{"maxChoices":_vm.election.max_choices},model:{value:(_vm.election.questionnaire),callback:function ($$v) {_vm.$set(_vm.election, "questionnaire", $$v)},expression:"election.questionnaire"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }